import React from 'react';
import { connect } from 'react-redux';
import get from 'lodash/get';
import find from 'lodash/find';
import Moment from 'moment';
import Currency from '../Currency';
import { formatQuantity } from '../SecurityDetail/SecurityDetail';
import { InlineTip } from '../Tooltip';

import BaseConfirmationScreen from '../BaseConfirmationScreen';

import './styles.css';

const UnconnectedTradeConfirm = (props) => {
  const {
    bankLinks,
    tradeSecurityInfo,
    tradeSecurityTransferInfo,
    currentPrice,
    transferFundsInfo,
  } = props;
  const {
    orderId,
    orderDate,
    requestDate,
    ticker,
    typeLabel,
    limitPrice,
    stopPrice,
    requestedShareAmount,
    termLabel,
    term,
    serviceFee,
    total,
  } = tradeSecurityInfo;
  let transferDetails;
  const isTransfer = tradeSecurityTransferInfo && tradeSecurityTransferInfo.transferAmount;
  if (isTransfer) {
    const transferBank = find(bankLinks, { bankLinkOid: tradeSecurityTransferInfo.from });
    transferDetails = (
      <div>
        <div styleName="displayRow">
          <div styleName="reviewLabels">Request Date</div>
          <div styleName="confirmDate">{Moment(transferFundsInfo.requestDate).format('MMM DD, YYYY')}</div>
        </div>
        <div styleName="reviewLabels">From</div>
        <div styleName="reviewFields">{`${transferBank.bankName} ${transferBank.bankAccountNumber}`}</div>
        <div styleName="reviewLabels">To</div>
        <div styleName="reviewFields">My IPO</div>
        <div styleName="reviewLabels">Transfer Amount</div>
        <Currency styleName="reviewAmount" amount={(Number.parseFloat(tradeSecurityTransferInfo.transferAmount))} />
      </div>
    );
  }
  return (
    <BaseConfirmationScreen
      backLabel="Summary"
      backTo="/portfolio"
      confirmationText={isTransfer ? 'Transfer Confirmed' : 'Order Confirmed'}
      header={isTransfer ?
        `Transfer Confirmation Number: ${transferFundsInfo.eftOid}` :
        `Order Confirmation Number: ${orderId}`}
    >
      {isTransfer ?
        <div styleName="transferReview">
          {transferDetails}
        </div>
        :
        <div styleName="tradeConfirm">
          <div styleName="displayRow">
            <div styleName="formLabelNoMargin">Request Date</div>
            <div styleName="formValueConfirmDate">{Moment(requestDate).format('MMM DD, YYYY')}</div>
          </div>
          <div styleName="displayRow">
            <div styleName="formLabelNoMargin">Order Date</div>
            <div styleName="formValueConfirmDate">
              <InlineTip text="The order date may be different from the request date depending on the time the order was placed.">
                <span>
                  {Moment(orderDate).format('MMM DD, YYYY')}
                </span>
              </InlineTip>
            </div>
          </div>
          <div styleName="displayRow">
            <div styleName="formLabelNoMargin">Security</div>
            <div styleName="formValue">{ticker}</div>
          </div>
          <div styleName="formLabelNoMargin">Order Type</div>
          <div styleName="selectReviewValue">{typeLabel}</div>
          <div styleName="displayRow">
            <div styleName="formLabelNoMargin">Market Price</div>
            <Currency styleName="formValue" amount={currentPrice} />
          </div>
          {stopPrice ?
            <div styleName="displayRow">
              <div styleName="formLabelNoMargin">Stop Price</div>
              <Currency styleName="formValue" amount={stopPrice} />
            </div> : null}
          {limitPrice ?
            <div styleName="displayRow">
              <div styleName="formLabelNoMargin">Limit Price</div>
              <Currency styleName="formValue" amount={limitPrice} />
            </div> : null}
          <div styleName="displayRow">
            <div styleName="formLabelNoMargin">Shares</div>
            <div styleName="formValue">{formatQuantity(Number.parseFloat(requestedShareAmount))}</div>
          </div>
          {term ?
            <div>
              <div styleName="formLabelNoMargin">Expiration</div>
              <div styleName="selectReviewValue">{termLabel}</div>
            </div> : null}
          <div styleName="breakLineTotal" />
          <div styleName="displayRow">
            <div styleName="formLabelNoMargin">Service Fee</div>
            <Currency styleName="formValue" amount={serviceFee} />
          </div>
          <div styleName="displayRow">
            <div styleName="formLabelNoMargin">Estimated Total</div>
            <Currency styleName="formValue" amount={total} />
          </div>
        </div>}
    </BaseConfirmationScreen>
  );
};

const mapStateToProps = state => ({
  bankLinks: get(state, `accountBankLinks.[${state.currentAccount}].data`, []),
  tradeSecurityInfo: get(state, 'tradeSecurityInfo.tradeInfo'),
  tradeSecurityTransferInfo: get(state, 'tradeSecurityInfo.transferInfo'),
  transferFundsInfo: get(state, 'transferFundsInfo.transferInfo'),
});


export default connect(mapStateToProps, null)(UnconnectedTradeConfirm);



// WEBPACK FOOTER //
// ./src/components/SecurityTrade/TradeConfirm.js